<template>
    <div>
        <vs-row>
            <vs-col vs-w="6">
                <vx-card :title="`Radar d'une personne`">
                    <vs-list-item v-for="listItem in entityValues.slice(0, 16)" :key="listItem.id"
                        :title="listItem.title">
                        <label> {{ listItem.rgb }}</label>
                        <input :id="'color_' + listItem.id" v-model="entityValues[listItem.id - 1].rgb" type="color" />
                    </vs-list-item>
                </vx-card>

                <vx-card class="mt-10" :title="`Autre Savoir-Faire`">
                    <vs-list-item v-for="listItem in entityValues.slice(34, 35)" :key="listItem.id" :title="listItem.title">
                        <label> {{ listItem.rgb }}</label>
                        <input :id="'color_' + listItem.id" v-model="entityValues[listItem.id - 1].rgb" type="color" />
                    </vs-list-item>
                </vx-card>

                <vx-card class="mt-10" :title="`Catégorie d'objectifs (savoir-faire, compétences et autres objectifs)`">
                    <vs-list-item v-for="listItem in entityValues.slice(47, 55)" :key="listItem.id" :title="listItem.title">
                        <label> {{ listItem.rgb }}</label>
                        <input :id="'color_' + listItem.id" v-model="entityValues[listItem.id - 1].rgb" type="color" />
                    </vs-list-item>
                </vx-card>

                <vx-card class="mt-10" :title="`Catégorie de compétences`">
                    <vs-list-item v-for="listItem in entityValues.slice(55, 65)" :key="listItem.id" :title="listItem.title">
                        <label> {{ listItem.rgb }}</label>
                        <input :id="'color_' + listItem.id" v-model="entityValues[listItem.id - 1].rgb" type="color" />
                    </vs-list-item>
                </vx-card>
            </vs-col>
            <vs-col vs-w="6">
                <vx-card :title="`Radar des postes/métiers`">
                    <vs-list-item v-for="listItem in entityValues.slice(16, 19)" :key="listItem.id" :title="listItem.title">
                        <label> {{ listItem.rgb }}</label>
                        <input :id="'color_' + listItem.id" v-model="entityValues[listItem.id - 1].rgb" type="color" />
                    </vs-list-item>
                </vx-card>

                <vx-card class="mt-10" :title="`Postes`">
                    <vs-list-item title="Différencier les Postes par une couleur différente ?">
                        <vs-switch v-model="differentColorsForJobs"/>
                    </vs-list-item>
                    <template v-if="differentColorsForJobs">
                        <vs-list-item v-for="listItem in entityValues.slice(19, 29)" :key="listItem.id" :title="listItem.title">
                            <label> {{ listItem.rgb }}</label>
                            <input :id="'color_' + listItem.id" v-model="entityValues[listItem.id - 1].rgb" type="color" />
                        </vs-list-item>
                    </template>
                    <template v-else>
                        <vs-list-item v-for="listItem in entityValues.slice(99, 100)" :key="listItem.id" :title="listItem.title">
                            <label> {{ listItem.rgb }}</label>
                            <input :id="'color_' + listItem.id" v-model="entityValues[listItem.id - 1].rgb" type="color" />
                        </vs-list-item>
                    </template>
                </vx-card>

                <vx-card class="mt-10" :title="`Métiers`">
                    <vs-list-item title="Différencier les Métiers par une couleur différente ?">
                        <vs-switch v-model="differentColorsForOccupations"/>
                    </vs-list-item>
                    <template v-if="differentColorsForOccupations">
                        <vs-list-item v-for="listItem in entityValues.slice(29, 34)" :key="listItem.id" :title="listItem.title">
                            <label> {{ listItem.rgb }}</label>
                            <input :id="'color_' + listItem.id" v-model="entityValues[listItem.id - 1].rgb" type="color" />
                        </vs-list-item>
                    </template>
                    <template v-else>
                        <vs-list-item v-for="listItem in entityValues.slice(100, 101)" :key="listItem.id" :title="listItem.title">
                            <label> {{ listItem.rgb }}</label>
                            <input :id="'color_' + listItem.id" v-model="entityValues[listItem.id - 1].rgb" type="color" />
                        </vs-list-item>
                    </template>
                </vx-card>

                <vx-card class="mt-10" :title="`Suivi des objectifs`">
                    <vs-list-item v-for="listItem in entityValues.slice(35, 47)" :key="listItem.id" :title="listItem.title">
                        <label> {{ listItem.rgb }}</label>
                        <input :id="'color_' + listItem.id" v-model="entityValues[listItem.id - 1].rgb" type="color" />
                    </vs-list-item>
                </vx-card>

                <vx-card class="mt-10">
                    <vs-row>
                        <vs-col vs-type="flex" vs-justify="center" style="display: inline-flex; align-items: center">
                            <vs-col vs-w="6">
                                <label style="font-weight: bold">Enregistrer les modifications</label>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-w="6">
                                <vs-button id="saveButton" @click="storeColors()">
                                    <i class="fa fa-floppy-o mr-2"></i>
                                    Enregistrer
                                </vs-button>
                            </vs-col>
                        </vs-col>
                    </vs-row>
                </vx-card>
                <vx-card class="mt-10">
                    <vs-row>
                        <vs-col vs-type="flex" vs-justify="center" style="display: inline-flex; align-items: center">
                            <vs-col vs-w="6">
                                <label style="font-weight: bold">Réinitialiser les paramètres</label>
                            </vs-col>
                            <vs-col vs-type="flex" vs-justify="center" vs-w="6">
                                <vs-button id="initButton" @click="resetColors()">
                                    <i class="fa fa-refresh mr-2"></i>
                                    Réinitialiser
                                </vs-button>
                            </vs-col>
                        </vs-col>
                    </vs-row>
                </vx-card>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>

export default {
    name: "Colors",
    props: {
        api: {
            type: String,
            required: true,
        },
        colors: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            err: false,
            //If we modifiy the number of color, we would have to modify the indexes in : "Graphics.vue", "ratingChartsHelper.js", "EmployeeInfo.vue"
            defaultColors: [],
            differentColorsForJobs: true,
            differentColorsForOccupations: true,
        };
    },

    computed: {
        entityValues() {
            if (this.items.length > 0) {
                return this.items;
            }
            return this.defaultColors;
        }
    },

    methods: {

        /**
         * Initialisation des couleurs après que le computed `projectNames` soit disponible
         */
        initDefaultColors() {
            this.defaultColors = this.colors;
        },

        storeColors() {
            this.loading = true;
            let count = 0;
            let error = 0;
            this.entityValues.forEach((item) => {
                if (!this.differentColorsForJobs && item.id >= 20 && item.id <= 29) {
                    item.rgb = this.items.find(i => i.id === 100).rgb
                }
                if (!this.differentColorsForOccupations && item.id >= 30 && item.id <= 34) {
                    item.rgb = this.items.find(i => i.id === 101).rgb
                }
                window
                    .axios({
                        method: "patch",
                        url: `${this.api}/${item.id}`,
                        data: item,
                    })
                    .then((response) => {
                        count++;

                        if (count == this.entityValues.length) {
                            if (error === 0) {
                                this.loading = false;
                                this.notifySuccess("Paramètres enregistrés !");
                            }
                        }
                    })
                    .catch((err, data) => {
                        this.notifyErrorValidation(err);
                        this.err = err;
                        error++;
                        count++;
                    });
            });
        },

        resetColors() {
            this.loading = true;
            let count = 0;
            let error = 0;

            this.$swal({
                title: `Êtes-vous sûr de vouloir réinitialiser les paramètres ?`,
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Ok",
                cancelButtonText: "Annuler",
            }).then(async (result) => {
                if (result.value) {
                    this.defaultColors.forEach((item) => {
                        window
                            .axios({
                                method: "patch",
                                url: `${this.api}/${item.id}`,
                                data: item,
                            })
                            .then((response) => {
                                count++;

                                if (count == this.entityValues.length) {
                                    if (error === 0) {
                                        this.loading = false;
                                        this.notifySuccess("Paramètres enregistrés !");
                                    }
                                }
                            })
                            .catch((err, data) => {
                                this.notifyErrorValidation(err);
                                this.err = err;
                                error++;
                                count++;
                            });
                    });

                    this.loadItems();
                }
            });
        },
    },
    created() {
        this.initDefaultColors();
        this.loadItems().then(() => {
            if (this.items.length > 0) {
                let jobColors = []
                jobColors.push(this.items.find(i => i.id === 20)?.rgb)
                jobColors.push(this.items.find(i => i.id === 21)?.rgb)
                jobColors.push(this.items.find(i => i.id === 22)?.rgb)
                jobColors.push(this.items.find(i => i.id === 23)?.rgb)
                jobColors.push(this.items.find(i => i.id === 24)?.rgb)
                jobColors.push(this.items.find(i => i.id === 25)?.rgb)
                jobColors.push(this.items.find(i => i.id === 26)?.rgb)
                jobColors.push(this.items.find(i => i.id === 27)?.rgb)
                jobColors.push(this.items.find(i => i.id === 28)?.rgb)
                jobColors.push(this.items.find(i => i.id === 29)?.rgb)
                let uniqueJobColor = [...new Set(jobColors)];
                if (uniqueJobColor.length === 1) {
                    this.differentColorsForJobs = false;
                    this.items.find(i => i.id === 100).rgb = uniqueJobColor[0]
                }

                let occupationColors = []
                occupationColors.push(this.items.find(i => i.id === 30)?.rgb)
                occupationColors.push(this.items.find(i => i.id === 31)?.rgb)
                occupationColors.push(this.items.find(i => i.id === 32)?.rgb)
                occupationColors.push(this.items.find(i => i.id === 33)?.rgb)
                occupationColors.push(this.items.find(i => i.id === 34)?.rgb)
                let uniqueOccColor = [...new Set(occupationColors)];
                if (uniqueOccColor.length === 1) {
                    this.differentColorsForOccupations = false;
                    this.items.find(i => i.id === 101).rgb = uniqueOccColor[0]
                }
            }
        })
    },
};
</script>
